export function defined(props) {
    const result = {};
    for (const key of Object.keys(props)) {
        const value = props[key];
        if (value !== undefined) {
            result[key] = value;
        }
    }
    return result;
}
export function withoutNulls(row) {
    const result = {};
    for (const key of Object.keys(row)) {
        const value = row[key];
        if (value !== null && value !== undefined) {
            result[key] = value;
        }
    }
    return result;
}
//# sourceMappingURL=defined.js.map